import { animate, animateChild, query, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { ApplicationDetail } from '@ca/core/models';
import { ApplicationType } from '../../../core/enums/application-type.enum';
import { ApplicationsFacadeService } from '../../../features/applications/services/applications-facade/applications-facade.service';

@Component({
    selector: 'ca-application-detail',
    templateUrl: './application-detail.component.html',
    styleUrls: ['./application-detail.component.scss'],
    providers: [ApplicationsFacadeService],
    animations: [
        trigger('ngIfAnimation', [transition(':enter, :leave', [query('@*', animateChild(), { optional: true })])]),
        trigger('easeInOut', [
            transition('void => *', [
                style({
                    opacity: 0,
                }),
                animate(
                    '500ms ease-in',
                    style({
                        opacity: 1,
                    }),
                ),
            ]),
            transition('* => void', [
                style({
                    opacity: 1,
                }),
                animate(
                    '500ms ease-in',
                    style({
                        opacity: 0,
                    }),
                ),
            ]),
        ]),
    ],
})
export class ApplicationDetailComponent {
    readonly ApplicationType = ApplicationType;

    @Input() application: ApplicationDetail;
    @Input() type: ApplicationType = ApplicationType.Public;
    @Input() displayName: string;
    @Input() hasToggle: boolean = true;

    toggled: boolean = true;
}
